import React from 'react';
import { IconButton, Stack, TooltipHost } from '@fluentui/react';
import Widgets from './components/Widgets/Widgets';
import BottomImageSection from './components/BottomImageSection';
import TopImageSection from './components/TopImageSection';
import { styles } from './PersonalMeetingCorner.styles';
import { useIsBottomImageExpanded } from './states/hooks';
import IvicosStrings from 'kits/language/stringKit';

interface PersonalMeetingCornerViewProps {
    isTopImageLoaded: boolean;
    setIsTopImageLoaded: (loaded: boolean) => void;
    isBottomImageLoaded: boolean;
    setIsBottomImageLoaded: (loaded: boolean) => void;
}

export const PersonalMeetingCornerView = ({
    isTopImageLoaded,
    setIsTopImageLoaded,
    isBottomImageLoaded,
    setIsBottomImageLoaded
}: PersonalMeetingCornerViewProps): JSX.Element => {
    const [isBottomImageExpanded, setIsBottomImageExpanded] = useIsBottomImageExpanded();
    return (
        <Stack className={styles.container}>
            <Stack>
                <TopImageSection isLoaded={isTopImageLoaded} setIsLoaded={setIsTopImageLoaded} />
                <Stack
                    style={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        bottom: isBottomImageExpanded ? '32%' : '4%',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background-color 0.2s ease',
                        backgroundColor: 'transparent',
                        borderRadius: '50%',
                        border: 'none'
                    }}
                >
                    {isBottomImageExpanded ? (
                        <TooltipHost content={IvicosStrings.personalMeetingCornerStrings.tooltips.collapseWidgets}>
                            <IconButton
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '50%'
                                }}
                                iconProps={{ iconName: 'DoubleChevronDown8' }}
                                onClick={() => {
                                    setIsBottomImageExpanded(false);
                                }}
                            />
                        </TooltipHost>
                    ) : (
                        <TooltipHost content={IvicosStrings.personalMeetingCornerStrings.tooltips.expandWidgets}>
                            <IconButton
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '50%'
                                }}
                                iconProps={{ iconName: 'DoubleChevronUp8' }}
                                onClick={() => {
                                    setIsBottomImageExpanded(true);
                                }}
                            />
                        </TooltipHost>
                    )}
                </Stack>
                <BottomImageSection isLoaded={isBottomImageLoaded} setIsLoaded={setIsBottomImageLoaded} />
            </Stack>
            {isBottomImageExpanded && <Widgets />}
        </Stack>
    );
};
